import { Home, Inbox, ListChecks, CalendarCheck, Users, Building2, Handshake, Briefcase, MapPinned, CreditCard, MessageSquare, BarChart3, Sparkles, Settings, FileText, LineChart, Activity, LifeBuoy, Warehouse } from "lucide-react";

export const CONTROL_CENTRE_NAV = [
  { label: "Control Centre", path: "/control-centre", icon: Home, implemented: true },
  { label: "Work Flow", path: "/control-centre/workflow", icon: ListChecks, implemented: true },
  { label: "Enquiries", path: "/control-centre/enquiries", icon: Inbox, implemented: true },
  { label: "Bookings", path: "/control-centre/bookings", icon: CalendarCheck, implemented: true },
  { label: "People", path: "/control-centre/people", icon: Users, implemented: true },
  { label: "Hotels & Properties", path: "/control-centre/properties", icon: Building2, implemented: true },
  { label: "Suppliers", path: "/control-centre/suppliers", icon: Handshake, implemented: true },
  { label: "Clients", path: "/control-centre/clients", icon: Briefcase, implemented: true },
  { label: "Allocations", path: "/control-centre/allocations", icon: MapPinned, implemented: true },
  { label: "Payments", path: "/control-centre/payments", icon: CreditCard, implemented: true },
  { label: "Communications", path: "/control-centre/communications", icon: MessageSquare, implemented: true },
  { label: "Support Inbox", path: "/control-centre/support-inbox", icon: LifeBuoy, implemented: true },
  { label: "Reports", path: "/control-centre/reports", icon: BarChart3, implemented: true },
  { label: "AI & Automations", path: "/control-centre/ai", icon: Sparkles, implemented: true },
  { label: "Admin", path: "/control-centre/admin", icon: Settings, implemented: true },
];

export const CLIENT_NAV = [
  { label: "Home", path: "/client", icon: Home, implemented: true },
  { label: "Requests", path: "/client/requests", icon: FileText, implemented: true },
  { label: "Bookings", path: "/client/bookings", icon: CalendarCheck, implemented: true },
  { label: "People", path: "/client/people", icon: Users, implemented: true },
  { label: "Properties", path: "/client/properties", icon: Warehouse, implemented: true },
  { label: "Documents", path: "/client/documents", icon: FileText, implemented: true },
  { label: "Analytics", path: "/client/analytics", icon: LineChart, implemented: true },
  { label: "Activity", path: "/client/activity", icon: Activity, implemented: true },
  { label: "Support", path: "/client/support", icon: LifeBuoy, implemented: true },
];

export const SUPPLIER_NAV = [
  { label: "Home", path: "/supplier", icon: Home, implemented: true },
  { label: "Properties", path: "/supplier/properties", icon: Warehouse, implemented: true },
  { label: "Compliance", path: "/supplier/compliance", icon: FileText, implemented: true },
  { label: "Submissions", path: "/supplier/submissions", icon: Inbox, implemented: true },
  { label: "Requests from Jigsaw", path: "/supplier/requests", icon: MessageSquare, implemented: true },
];
